module.exports = __webpack_public_path__ + "img/vip-tag-advanced.fb260774.png";